import Monard91 from '../../../BSD/Armont/Monard/Monard 9 .webp'
import Monard92 from '../../../BSD/Armont/Monard/Monard 9 .webp'



const Monard9images =[
Monard91,Monard92
]

export default Monard9images;